import React, { useContext } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import get from 'lodash/get';
import { Table as BootstrapTable } from 'react-bootstrap';

// HELPERS
import { ListContext } from 'helpers/getListData';

// PARTS
import Table from 'parts/table/Table';

// STYLES
import styles from './totalTable.module.scss';

// MAIN COMPONENT
const TotalTable = ({ columns, headerLabels, className }) => {
  // CONTEXT
  const { result, data } = useContext(ListContext) || {};

  // RENDER
  return columns?.length && result?.length ? (
    <BootstrapTable className={clsx('mt-4 mb-0 ms-auto border', styles.table, className)} size="sm">
      {headerLabels?.length && (
        <thead>
          <tr>
            {headerLabels.map((label, i) => (
              <th key={i} className={i !== 0 && 'text-end'}>
                {label}
              </th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {columns.map((row, i) => (
          <tr key={i}>
            {row.map(({ key, label }, j) => (
              <td key={j}>
                {j === 0 ? label : <Table.Dollars placeholder={<>&ndash;</>}>{get(data, key)}</Table.Dollars>}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </BootstrapTable>
  ) : null;
};

// EXPORT
export default TotalTable;
